module.exports = __webpack_public_path__ + "ptc_momoro_L2.53267c51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_L2.jpg
// module id = izBD
// module chunks = 0